import { useAppSelector } from 'state/hooks'
import { MetaBroker, FormattedPositions } from 'state/mock'
import { DashTab, selectColumns } from 'state/slices/ui/dash'
import { selectFormLabelsByDashTab } from 'state/slices/ui/form'
import { types } from '@concordia/super-sdk'
import { selectTotalCollateral } from 'state/slices/user/portfolio'
import FlashRow from './FlashRow'
import { selectBrokersErrored, selectBrokersLoaded } from 'state/slices/app/brokers'
import { memo, useMemo } from 'react'
import { MobileBrokerCard } from './MobileBrokerCard'

export interface MobileListProps {
  brokers: MetaBroker[]
  isLoadedApp: boolean
  tab: DashTab
  positions: FormattedPositions
  isLoadedUser: boolean
  balances: types.SWalletBalance[]
}

const MobileBrokerCardMemo = memo(MobileBrokerCard)

function MobileList({
  brokers,
  isLoadedApp,
  tab,
  isLoadedUser,
  positions,
  balances
}: MobileListProps) {
  const formTabs = useAppSelector(selectFormLabelsByDashTab)
  const userCollat = useAppSelector(selectTotalCollateral)
  const isLoadedBrokers = useAppSelector(selectBrokersLoaded)
  const isBrokersErrored = useAppSelector(selectBrokersErrored)
  const displayListTop = useMemo(
    () =>
      brokers?.map((b, i) => (
        <MobileBrokerCardMemo
          broker={b}
          key={b.underlyingAsset.name + 'a'}
          tab={tab}
          isLoadedUser={isLoadedUser}
          positions={positions}
          balances={balances}
          showBalRow={true}
          isLoadedApp={isLoadedApp}
          formTabs={formTabs}
          userCollat={userCollat}
          isLoadedBrokers={isLoadedBrokers}
        />
      )),
    [
      brokers,
      tab,
      isLoadedUser,
      positions,
      balances,
      isLoadedApp,
      formTabs,
      userCollat,
      isLoadedBrokers
    ]
  )
  const displayListBelow = useMemo(
    () =>
      brokers?.map((b, i) => (
        <MobileBrokerCardMemo
          broker={b}
          key={b.underlyingAsset.name + 'b'}
          tab={tab}
          isLoadedUser={isLoadedUser}
          positions={positions}
          balances={balances}
          showBalRow={false}
          isLoadedApp={isLoadedApp}
          formTabs={formTabs}
          userCollat={userCollat}
          isLoadedBrokers={isLoadedBrokers}
        />
      )),
    [
      brokers,
      tab,
      isLoadedUser,
      positions,
      balances,
      isLoadedApp,
      formTabs,
      userCollat,
      isLoadedBrokers
    ]
  )

  if (!isLoadedApp && !isBrokersErrored) {
    return (
      <div className="broker-list">
        <div className="rows">
          <hr className="hr" />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
          <FlashRow />
        </div>
      </div>
    )
  }

  return (
    <div className="broker-list">
      <div className="rows">
        {displayListTop}

        <hr className="hr" />
        {displayListBelow}
      </div>
    </div>
  )
}

export default MobileList
